import { useQuery } from "@apollo/client";
import { GET_CHILDREN } from "@/modules/common/entities/company-structure/select/api/get-children";
import {
  CompanyStructureSelectOptionFragment,
  HierarchyElementType,
  HierarchyType,
} from "gql/graphql";

export function useCompanyStructureAll({
  types,
  hierarchyType = HierarchyType.Structure,
  skip = false,
}: {
  types?: HierarchyElementType[];
  hierarchyType?: HierarchyType;
  skip?: boolean;
}) {
  const { data, loading } = useQuery(GET_CHILDREN, {
    variables: {
      types,
      hierarchyType,
    },
    skip,
  });

  const nodes: CompanyStructureSelectOptionFragment[] =
    data?.getAllCompanyHierarchyElements ?? [];

  return {
    nodes,
    loading,
  };
}
